import { getProgramTypesUrl } from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class ProgramTypeService {
  static getProgramTypes = () => {
    return getRequest(getProgramTypesUrl());
  };

  static createProgramType = (programType) => {
    return postRequest(getProgramTypesUrl(), programType);
  };

  static getProgramTypeById = (programTypeId) => {
    return getRequest(getProgramTypesUrl() + "/" + programTypeId);
  };

  static updateProgramType = (programType) => {
    return putRequest(getProgramTypesUrl() + "/" + programType.id, programType);
  };

  static deleteProgramType = (programTypeId) => {
    return deleteRequest(getProgramTypesUrl() + "/" + programTypeId);
  };
}
